// src/config.js
const config = {
    apiUrl: 'https://www.pharmsultation.com',
    consumerKey: 'ck_d67effbe66ed5a1e12d7baacb6d67890c9bc2191',
    consumerSecret: 'cs_0149df80d3ea037c94b7e10aafb298aad54c189e',
};

export default config;
